import { ButtonColorVariant } from "@/components/ui/button";
import type { CustomerCompanyAction } from "../../_helpers/customer-company-selection";

export type CustomerCompanyActionDialogContent = {
  titleKey: string;
  descriptionKey: string;
  selectionLabelKey: string;
  submitKey: string;
  submitColor: ButtonColorVariant;
};

export function getCustomerCompanyActionDialogContent(
  action: CustomerCompanyAction,
): CustomerCompanyActionDialogContent {
  if (action.type === "bulk-delete") {
    return {
      titleKey: "masterdata:CustomerBulkDeleteCompanyPickerTitle",
      descriptionKey: "masterdata:CustomerBulkDeleteCompanyPickerDescription",
      selectionLabelKey: "masterdata:CustomerBulkDeleteCompanies",
      submitKey: "masterdata:CustomerBulkDeleteSubmit",
      submitColor: ButtonColorVariant.Error,
    };
  }

  return {
    titleKey: "masterdata:CustomerFullSyncCompanyPickerTitle",
    descriptionKey: action.force
      ? "masterdata:CustomerForcedFullSyncCompanyPickerDescription"
      : "masterdata:CustomerFullSyncCompanyPickerDescription",
    selectionLabelKey: "masterdata:CustomerFullSyncCompaniesToSync",
    submitKey: action.force ? "masterdata:CustomerForcedFullSyncSubmit" : "masterdata:CustomerFullSyncSubmit",
    submitColor: ButtonColorVariant.Primary,
  };
}
